(function () {
  var COMPANY_MSG = "Enter your company name.";
  var ALLOWED = /\.(png|jpe?g|pdf|ai|svg)$/i;
  var MAX = 25 * 1024 * 1024;


  var UBX_SKU_TREE = {"Men's Custom":{"_all":[{"code":"AOP3Qtr","label":"AOP3Qtr \u2014 Men's 3/4 Sleeve T-Shirt"},{"code":"AOPATHSHT","label":"AOPATHSHT \u2014 Men's Hybrid Athletic Shorts"},{"code":"AOPBH","label":"AOPBH \u2014 Reversible Bucket Hat"},{"code":"AOPMPS","label":"AOPMPS \u2014 Men's Polo Shirt"},{"code":"AOPCAS","label":"AOPCAS \u2014 Compression Arm Sleeve"},{"code":"AOPSP","label":"AOPSP \u2014 Surf Poncho"},{"code":"AOPBB2BTTNJ","label":"AOPBB2BTTNJ \u2014 2-Button Henley Baseball Jersey"},{"code":"AOPBBFBTTNJ","label":"AOPBBFBTTNJ \u2014 Full Button Baseball Jersey"},{"code":"AOPSLHD","label":"AOPSLHD \u2014 Men's Sleeveless Hoodie"},{"code":"AOPTT","label":"AOPTT \u2014 Men's Tank-Top"},{"code":"AOPTS","label":"AOPTS \u2014 Essential Short Sleeve CrewNeck Jersey/Tee"},{"code":"AOPLSBTTNUP","label":"AOPLSBTTNUP \u2014 Men's Long Sleeve Button-Up Shirt"},{"code":"AOPTSLS","label":"AOPTSLS \u2014 Kore Custom Dye Sublimated Long Sleeve T-Shirt - USA Made"},{"code":"AOPSS","label":"AOPSS \u2014 Unisex 12oz Fleece Sweater"},{"code":"AOPBJ","label":"AOPBJ \u2014 Unisex Bomber Jacket"},{"code":"AOPJGR","label":"AOPJGR \u2014 Unisex Fleece Joggers"},{"code":"AOPHD","label":"AOPHD \u2014 Unisex Pullover Hoodie"},{"code":"AOPQTRZ","label":"AOPQTRZ \u2014 Unisex Quarter-Zip Jacket"},{"code":"AOPPHDSS","label":"AOPPHDSS \u2014 Unisex Short Sleeve Pullover Hoodie - Shooting Shirt"},{"code":"AOPMTJ","label":"AOPMTJ \u2014 Unisex Track Jacket"},{"code":"AOPZHD","label":"AOPZHD \u2014 Unisex Zip-Up Pullover Hoodie"},{"code":"AOPBTTNUPSS","label":"AOPBTTNUPSS \u2014 Men's Button-Up Shirt"},{"code":"AOPPHDLS","label":"AOPPHDLS \u2014 Unisex Long Sleeve Pullover Hoodie - Fishing Shirt - USA Made"},{"code":"AOPBSPC","label":"AOPBSPC \u2014 Custom Men's Boardshorts - Premium Cut"},{"code":"AOPTSVNK","label":"AOPTSVNK \u2014 Essential Short Sleeve VNeck Jersey/Tee"},{"code":"AOPPESJ","label":"AOPPESJ \u2014 Premium Soccer Jersey"}]},"Women's Custom":{"_all":[{"code":"AOPDRSK","label":"AOPDRSK \u2014 Women's Skater Dress"},{"code":"AOP1PBS","label":"AOP1PBS \u2014 Women's 1-Piece Swimsuit"},{"code":"AOPCAS","label":"AOPCAS \u2014 Compression Arm Sleeve"},{"code":"AOPSP","label":"AOPSP \u2014 Surf Poncho"},{"code":"AOPJGR","label":"AOPJGR \u2014 Unisex Fleece Joggers"},{"code":"AOPHD","label":"AOPHD \u2014 Unisex Pullover Hoodie"},{"code":"AOPQTRZ","label":"AOPQTRZ \u2014 Unisex Quarter-Zip Jacket"},{"code":"AOPPHDSS","label":"AOPPHDSS \u2014 Unisex Short Sleeve Pullover Hoodie - Shooting Shirt"},{"code":"AOPMTJ","label":"AOPMTJ \u2014 Unisex Track Jacket"},{"code":"AOPZHD","label":"AOPZHD \u2014 Unisex Zip-Up Pullover Hoodie"},{"code":"AOP2PL","label":"AOP2PL \u2014 Women's Fashion Legging"},{"code":"AOPWSPBR","label":"AOPWSPBR \u2014 Women's Sports Bra"},{"code":"AOPWTS","label":"AOPWTS \u2014 Women's T-Shirt"},{"code":"AOP6PL","label":"AOP6PL \u2014 Women's Yoga Legging"},{"code":"AOPRT","label":"AOPRT \u2014 Women's Racerback Tank"},{"code":"AOPPHDLS","label":"AOPPHDLS \u2014 Unisex Long Sleeve Pullover Hoodie - Fishing Shirt - USA Made"}]},"Custom Accessories":{"_all":[{"code":"AOPSTFBLNKT6080","label":"AOPSTFBLNKT6080 \u2014 Sublimated 280gsm Silky Touch Fleece Blanket- 60\" x 80\" - Printed/Pressed in USA"},{"code":"AOPSTFBLNKT5060","label":"AOPSTFBLNKT5060 \u2014 Sublimated 280gsm Silky Touch Fleece Blanket- 50\" X 60\" - Printed/Pressed in USA"},{"code":"AOPSTFBLNKT4050","label":"AOPSTFBLNKT4050 \u2014 Sublimated 280gsm Silky Touch Fleece Blanket- 40\" X 50\" - Printed/Pressed in USA"},{"code":"AOPSTFBLNKT3040","label":"AOPSTFBLNKT3040 \u2014 Sublimated 280gsm Silky Touch Fleece Blanket- 30\" X 40\" - Printed/Pressed in USA"},{"code":"AOPSP","label":"AOPSP \u2014 Full Custom Bathrobes"},{"code":"AOPHDBLNKT5060","label":"AOPHDBLNKT5060 \u2014 Hooded Blanket - 50\"X60\""},{"code":"AOPHDBLNKT6080","label":"AOPHDBLNKT6080 \u2014 Hooded Blanket - 60\"X80\""},{"code":"AOPBLNKT5060","label":"AOPBLNKT5060 \u2014 Custom 50\" x 60\" Micro Fleece Blanket"},{"code":"AOPBLNKT6080Sherpa","label":"AOPBLNKT6080Sherpa \u2014 Custom Sublimated 60x80 Sherpa Blanket"},{"code":"AOPBT3060","label":"AOPBT3060 \u2014 Full Color 15oz 30\" x 60\" Beach Towel"},{"code":"GTR1000PRT","label":"GTR1000PRT \u2014 Custom Gaiter - GTR1000PRT"},{"code":"BNDA1000PRT","label":"BNDA1000PRT \u2014 Moisture Wicking Bandanna"},{"code":"AOPBH","label":"AOPBH \u2014 Reversible Bucket Hat"},{"code":"AOPBN","label":"AOPBN \u2014 Winter Beanie"},{"code":"AOPCAS","label":"AOPCAS \u2014 Compression Arm Sleeve"},{"code":"AOPSCS","label":"AOPSCS \u2014 Crew Socks"},{"code":"AOPPS","label":"AOPPS \u2014 Premium Full Color Chiffon 28\"x56\" Scarves"},{"code":"AOPTB1514","label":"AOPTB1514 \u2014 Denier Tote Bag"},{"code":"AOPRTL","label":"AOPRTL \u2014 Gym/Golf/Rally Towel - AOPRTL"},{"code":"AOPPPSQ","label":"AOPPPSQ \u2014 Premium Full Color Chiffon 13\"x13\" Pocket Square - HankScarves"}]},"Sports Uniforms":{"Hockey":[{"code":"AOPHVNJ","label":"AOPHVNJ \u2014 Hockey V-Neck Jersey"},{"code":"AOPHCLNJ","label":"AOPHCLNJ \u2014 Hockey Lace Neck Jersey"},{"code":"AOPHC1PSC","label":"AOPHC1PSC \u2014 Hockey One Piece Sock"},{"code":"AOPHCPRSC","label":"AOPHCPRSC \u2014 Hockey Pro Sock"},{"code":"AOPHCEWPS","label":"AOPHCEWPS \u2014 Elastic Waist Hockey Pant Shell"},{"code":"AOPHCBPS","label":"AOPHCBPS \u2014 Hockey Belted Pant Shell"},{"code":"AOPHVNRJ","label":"AOPHVNRJ \u2014 Reversible Hockey V-Neck Jersey"}],"Football":[{"code":"AOPFJVN","label":"AOPFJVN \u2014 Football Traditional Fan Jersey"},{"code":"AOPFPJ","label":"AOPFPJ \u2014 Football Fitted Jersey"}],"Basketball":[{"code":"AOPTS","label":"AOPTS \u2014 Essential Basketball Jersey"},{"code":"AOPBKSLCNJ","label":"AOPBKSLCNJ \u2014 Sleeveless Basketball Jersey Crewneck"},{"code":"AOPATHSHT","label":"AOPATHSHT \u2014 Basketball Game Shorts"},{"code":"AOPPHDSS","label":"AOPPHDSS \u2014 Unisex Short Sleeve Pullover Hoodie - Shooting Shirt"},{"code":"AOPBKSLCNJR","label":"AOPBKSLCNJR \u2014 Reversible Basketball Sleeveless Jersey"},{"code":"AOPPHDLS","label":"AOPPHDLS \u2014 Unisex Long Sleeve Pullover Hoodie - Fishing Shirt - USA Made"},{"code":"AOPBKSLVNJ","label":"AOPBKSLVNJ \u2014 Sleeveless Basketball Jersey VNeck"}],"Volleyball":[{"code":"AOPVBLSJ","label":"AOPVBLSJ \u2014 Volleyball Long Sleeve Jersey"},{"code":"AOPVBSSJ","label":"AOPVBSSJ \u2014 Volleyball Short Sleeve Jersey"},{"code":"AOPATHSHT","label":"AOPATHSHT \u2014 Volleyball Mesh Shorts"}],"Baseball":[{"code":"AOPTS","label":"AOPTS \u2014 Short Sleeve Crewneck Jersey"},{"code":"AOPBBFBTTNJ","label":"AOPBBFBTTNJ \u2014 Full Button Baseball Jersey"},{"code":"AOPBB2BTTNJ","label":"AOPBB2BTTNJ \u2014 2-Button Henley Baseball Jersey"}],"Softball":[{"code":"AOPTS","label":"AOPTS \u2014 Essential Softball Jersey"},{"code":"AOPATHSHT","label":"AOPATHSHT \u2014 SOFTBALL Mesh Shorts"}],"Lacrosse":[{"code":"AOPPLCJ","label":"AOPPLCJ \u2014 Lacrosse Short Sleeve Jersey"},{"code":"AOPTS","label":"AOPTS \u2014 Essential Lacrosse Jersey"},{"code":"AOPATHSHT","label":"AOPATHSHT \u2014 Lacrosse Mesh Shorts"}],"E-Sports":[{"code":"AOPTS","label":"AOPTS \u2014 Essential E-Sports Jersey"},{"code":"AOPPESJ","label":"AOPPESJ \u2014 Premium E-Sports Jersey"}],"Soccer":[{"code":"AOPTS","label":"AOPTS \u2014 Essential Short Sleeve CrewNeck Jersey/Tee"},{"code":"AOPPESJ","label":"AOPPESJ \u2014 Premium Soccer Jersey"},{"code":"AOPATHSHT","label":"AOPATHSHT \u2014 Soccer Game Shorts"},{"code":"AOPTSVNK","label":"AOPTSVNK \u2014 Essential Short Sleeve VNeck Jersey/Tee"}]}};

  function fillSelect(sel, placeholder, items, useCode) {
    sel.innerHTML = "";
    var ph = document.createElement("option");
    ph.value = "";
    ph.textContent = placeholder;
    sel.appendChild(ph);
    (items || []).forEach(function (item) {
      var opt = document.createElement("option");
      if (typeof item === "string") {
        opt.value = item;
        opt.textContent = item;
      } else {
        opt.value = useCode ? item.code : item;
        opt.textContent = useCode ? item.label : item;
      }
      sel.appendChild(opt);
    });
  }

function initQtyMode(root) {
    var wrap = root.querySelector("[data-ubx-qty]");
    if (!wrap) return;
    var mode = wrap.querySelector("[data-ubx-qty-mode]");
    var totalBox = wrap.querySelector("[data-ubx-qty-total]");
    var sizesBox = wrap.querySelector("[data-ubx-qty-sizes]");
    var sumEl = wrap.querySelector("[data-ubx-qty-sum]");
    var breakdown = wrap.querySelector("[data-ubx-qty-breakdown]");
    var totalInput = wrap.querySelector('input[name="quantity"]');
    var sizeNames = ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"];

    function sizeTotal() {
      var total = 0;
      var parts = [];
      sizeNames.forEach(function (sz) {
        var el = wrap.querySelector('input[name="qty' + sz + '"]');
        var n = el ? Number(el.value) : 0;
        if (!Number.isFinite(n) || n < 0) n = 0;
        if (n > 0) {
          total += n;
          parts.push(n + " " + sz);
        }
      });
      if (sumEl) sumEl.textContent = "Size total: " + total + (parts.length ? " (" + parts.join(", ") + ")" : "");
      if (breakdown) breakdown.value = parts.join(", ");
      return total;
    }

    function sync() {
      var m = mode ? mode.value : "total";
      if (totalBox) totalBox.hidden = m !== "total";
      if (sizesBox) sizesBox.hidden = m !== "sizes";
      if (m === "sizes") {
        var t = sizeTotal();
        if (totalInput) totalInput.value = t > 0 ? String(t) : "";
      } else if (breakdown) {
        breakdown.value = "";
      }
    }

    if (mode) mode.addEventListener("change", sync);
    wrap.addEventListener("input", function (e) {
      if (e.target && String(e.target.name || "").indexOf("qty") === 0) sync();
    });
    sync();
  }



  function stylesForCategory(c) {
    var node = UBX_SKU_TREE[c];
    if (!node) return [];
    if (node._all) return node._all.slice();
    var out = [];
    Object.keys(node).forEach(function (sport) {
      (node[sport] || []).forEach(function (item) {
        out.push({ code: item.code, label: sport + " — " + item.label });
      });
    });
    return out;
  }

  function initSkuCascade(root) {
    var wrap = root.querySelector("[data-ubx-sku]");
    if (!wrap || !UBX_SKU_TREE) return;
    var cat = wrap.querySelector("[data-ubx-sku-cat]");
    var sub = wrap.querySelector("[data-ubx-sku-sub]");
    var subWrap = wrap.querySelector("[data-ubx-sku-sub-wrap]");
    var subLabel = wrap.querySelector("[data-ubx-sku-sub-label]");
    var code = wrap.querySelector("[data-ubx-sku-code]");
    var codeLabel = wrap.querySelector("[data-ubx-sku-code-label]");
    var catVal = wrap.querySelector("[data-ubx-sku-cat-val]");
    var subVal = wrap.querySelector("[data-ubx-sku-sub-val]");
    if (!cat || !code) return;

    function setCodeLabel(text) {
      if (codeLabel) codeLabel.textContent = text;
    }
    function setSubLabel(text) {
      if (subLabel) subLabel.textContent = text;
    }

    function loadStyles(c, s) {
      code.value = "";
      var list;
      if (c === "Sports Uniforms") {
        list = (UBX_SKU_TREE[c] && UBX_SKU_TREE[c][s]) || [];
      } else {
        list = stylesForCategory(c);
      }
      if (!list.length) {
        code.disabled = true;
        fillSelect(code, c ? "No styles in this group" : "Select category first", []);
        return;
      }
      code.disabled = false;
      fillSelect(code, "Please select a product / SKU", list, true);
    }

    function onCategory() {
      var c = cat.value;
      if (catVal) catVal.value = c;
      if (subVal) subVal.value = "";
      code.value = "";

      if (!c || !UBX_SKU_TREE[c]) {
        if (subWrap) subWrap.hidden = true;
        if (sub) {
          sub.disabled = true;
          sub.removeAttribute("required");
          fillSelect(sub, "Select category first", []);
        }
        code.disabled = true;
        fillSelect(code, "Select category first", []);
        setCodeLabel("Product / SKU");
        return;
      }

      if (c === "Sports Uniforms") {
        // Category → Sport → SKU
        if (subWrap) subWrap.hidden = false;
        setSubLabel("Sport");
        setCodeLabel("Product / SKU");
        if (sub) {
          sub.disabled = false;
          sub.setAttribute("required", "required");
          fillSelect(sub, "Please select a sport", Object.keys(UBX_SKU_TREE[c]));
        }
        code.disabled = true;
        fillSelect(code, "Select sport first", []);
      } else {
        // Category → Product/SKU only (Men's / Women's / Accessories)
        if (subWrap) subWrap.hidden = true;
        if (sub) {
          sub.disabled = true;
          sub.removeAttribute("required");
          fillSelect(sub, "", ["_all"]);
          sub.value = "_all";
        }
        if (subVal) subVal.value = "";
        setCodeLabel("Product / SKU");
        loadStyles(c, "_all");
      }
    }

    cat.addEventListener("change", onCategory);
    if (sub) {
      sub.addEventListener("change", function () {
        var c = cat.value;
        var s = sub.value;
        if (subVal) subVal.value = s === "_all" ? "" : s;
        if (c === "Sports Uniforms") {
          if (!s) {
            code.disabled = true;
            fillSelect(code, "Select sport first", []);
            return;
          }
          loadStyles(c, s);
        }
      });
    }

    onCategory();
  }

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  ready(function () {
    document.querySelectorAll(".ubx-mr").forEach(initRoot);
  });

  function initRoot(root) {
    initSkuCascade(root);
    initQtyMode(root);

    var apiBase = (root.getAttribute("data-api-base") || "").replace(/\/$/, "");
    var submitUrl =
      root.getAttribute("data-submit-url") ||
      (apiBase ? apiBase + "/api/mockup-request" : "");
    var customerId = root.getAttribute("data-customer-id") || "";
    var customerEmail = root.getAttribute("data-customer-email") || "";
    var form = root.querySelector("[data-ubx-form]");
    var thanks = root.querySelector("[data-ubx-thanks]");
    var refEl = root.querySelector("[data-ubx-ref]");
    var again = root.querySelector("[data-ubx-again]");
    var nfrBox = root.querySelector("[data-ubx-nfr]");
    var fileMeta = root.querySelector("[data-ubx-file]");
    var preview = root.querySelector("[data-ubx-preview]");
    var formError = root.querySelector("[data-ubx-form-error]");
    var submitBtn = root.querySelector("[data-ubx-submit]");

    var dateMode = root.querySelector("[data-ubx-date-mode]");
    var dateInput = root.querySelector("[data-ubx-date-input]");
    function syncDateMode() {
      if (!dateMode || !dateInput) return;
      var known = dateMode.value === "known";
      dateInput.hidden = !known;
      if (!known) dateInput.value = "";
      else dateInput.focus();
    }
    if (dateMode) {
      dateMode.addEventListener("change", syncDateMode);
      syncDateMode();
    }

    if (again) {
      again.addEventListener("click", function () {
        thanks.hidden = true;
        form.hidden = false;
        form.reset();
        if (preview) {
          preview.hidden = true;
          preview.removeAttribute("src");
        }
        if (fileMeta) fileMeta.hidden = true;
      });
    }

    var logoInput = form && form.elements.logo;
    if (logoInput) {
      logoInput.addEventListener("change", function () {
        var files = logoInput.files ? Array.prototype.slice.call(logoInput.files) : [];
        if (!files.length) return;
        if (fileMeta) {
          fileMeta.hidden = false;
          fileMeta.textContent =
            files.length +
            " file" +
            (files.length > 1 ? "s" : "") +
            ": " +
            files
              .map(function (f) {
                return f.name + " (" + Math.ceil(f.size / 1024) + " KB)";
              })
              .join(", ");
        }
        if (preview) {
          var firstImg = null;
          for (var i = 0; i < files.length; i++) {
            if (files[i].type.indexOf("image/") === 0) {
              firstImg = files[i];
              break;
            }
          }
          if (firstImg) {
            preview.src = URL.createObjectURL(firstImg);
            preview.hidden = false;
          } else {
            preview.hidden = true;
          }
        }
        clearError(form, "logo");
      });
    }

    if (form) {
      form.addEventListener("input", function (event) {
        var name = event.target && event.target.name;
        if (!name) return;
        clearError(form, name);
        if (name === "company" && nfrBox) nfrBox.classList.remove("is-invalid");
      });
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        hide(formError);
        var errors = validate(form);
        paintErrors(form, nfrBox, errors);
        if (Object.keys(errors).length) return;

        if (!submitUrl) {
          show(
            formError,
            "Submit URL is not set. Paste the staging API origin (or /apps/ubx-mockup/submit later). Shopify contact forms cannot upload files. Nothing was submitted."
          );
          return;
        }

        if (!customerId || !customerEmail) {
          show(formError, "Sign in to request a mockup.");
          return;
        }

        var body = new FormData(form);
        // Re-append files under logo so staging can use getAll("logo")
        if (form.elements.logo && form.elements.logo.files) {
          body.delete("logo");
          Array.prototype.forEach.call(form.elements.logo.files, function (f) {
            body.append("logo", f, f.name);
          });
        }
        body.set("shopifyCustomerId", customerId);
        body.set("shopifyCustomerEmail", customerEmail);
        if (form.elements.dateNeededMode && form.elements.dateNeededMode.value !== "known") {
          body.set("dateNeeded", "");
          body.set("dateNeededMode", "unknown");
        }
        submitBtn.disabled = true;
        submitBtn.textContent = "Submitting…";

        fetch(submitUrl, {
          method: "POST",
          body: body,
        })
          .then(function (res) {
            return res.json().then(function (json) {
              return { ok: res.ok, json: json };
            });
          })
          .then(function (result) {
            submitBtn.disabled = false;
            submitBtn.textContent = "Request free proof";
            if (!result.ok || !result.json.ok) {
              paintErrors(form, nfrBox, result.json.errors || {});
              show(
                formError,
                result.json.message ||
                  "The request was not accepted. Fix the errors below."
              );
              return;
            }
            form.hidden = true;
            thanks.hidden = false;
            if (refEl) {
              refEl.textContent = "Reference: " + (result.json.referenceId || "");
            }
            var trackEl = root.querySelector("[data-ubx-track]");
            if (trackEl) {
              var trackUrl = result.json.trackUrl || "";
              if (trackUrl) {
                trackEl.innerHTML =
                  'Track your project: <a href="' + trackUrl + '" target="_blank" rel="noopener">' + trackUrl + "</a>" +
                  "<br><small>Bookmark it. It follows your project from concept to delivery.</small>";
                trackEl.hidden = false;
              } else {
                trackEl.hidden = true;
              }
            }
          })
          .catch(function () {
            submitBtn.disabled = false;
            submitBtn.textContent = "Request free proof";
            show(formError, "Network error. Nothing was submitted.");
          });
      });
    }

  }

  function validate(form) {
    var errors = {};
    var required = [
      ["firstName", "Enter your first name."],
      ["lastName", "Enter your last name."],
      ["email", "Enter a valid email address."],
      ["productCode", "Select a product."],
      ["notes", "Add design notes (colors, placement, names/numbers)."],
    ];
    required.forEach(function (pair) {
      var el = form.elements[pair[0]];
      if (!el || String(el.value || "").trim() === "") errors[pair[0]] = pair[1];
    });
    var email = form.elements.email.value.trim();
    if (email && email.indexOf("@") === -1) {
      errors.email = "Enter a valid email address.";
    }
    var qtyMode = form.elements.quantityMode
      ? form.elements.quantityMode.value
      : "total";
    if (qtyMode === "sizes") {
      var sizeNames = ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"];
      var sizeSum = 0;
      var parts = [];
      sizeNames.forEach(function (sz) {
        var el = form.elements["qty" + sz];
        var n = el ? Number(el.value) : 0;
        if (Number.isFinite(n) && n > 0) {
          sizeSum += n;
          parts.push(n + " " + sz);
        }
      });
      if (sizeSum < 1) {
        errors.quantity = "Enter at least one size qty (e.g. 10 S, 10 M, 10 L).";
      } else {
        form.elements.quantity.value = String(sizeSum);
        if (form.elements.quantityBreakdown) {
          form.elements.quantityBreakdown.value = parts.join(", ");
        }
      }
    } else {
      var qty = Number(form.elements.quantity.value);
      if (!form.elements.quantity.value || !Number.isInteger(qty) || qty < 1) {
        errors.quantity = "Enter a total qty of 1 or more (approx is fine).";
      }
      if (form.elements.quantityBreakdown) form.elements.quantityBreakdown.value = "";
    }
    var phone = form.elements.phone.value.trim();
    if (phone) {
      var digits = phone.replace(/\D/g, "");
      if (digits.length < 10 || digits.length > 15) {
        errors.phone = "Enter a valid phone number, including area code.";
      }
    }
    var company = form.elements.company.value.trim();
    if (!company) errors.company = COMPANY_MSG;
    var cid = form.elements.shopifyCustomerId && form.elements.shopifyCustomerId.value;
    if (!cid) {
      errors.shopifyCustomerId = "Sign in to request a mockup.";
    }

    var dateMode = form.elements.dateNeededMode
      ? form.elements.dateNeededMode.value
      : "unknown";
    var dateEl = form.elements.dateNeeded;
    if (dateMode === "known") {
      if (!dateEl || String(dateEl.value || "").trim() === "") {
        errors.dateNeeded = "Pick a date, or choose Don't have one yet.";
      }
    } else if (dateEl) {
      dateEl.value = "";
    }

    var files = form.elements.logo.files
      ? Array.prototype.slice.call(form.elements.logo.files)
      : [];
    if (!files.length) errors.logo = "Upload at least one logo or reference file.";
    else {
      for (var fi = 0; fi < files.length; fi++) {
        var file = files[fi];
        if (!ALLOWED.test(file.name) || file.size > MAX) {
          errors.logo =
            "Each file must be PNG, JPG, PDF, AI, or SVG (max 25 MB). Problem: " +
            file.name;
          break;
        }
      }
    }
    return errors;
  }

  function paintErrors(form, nfrBox, errors) {
    form.querySelectorAll("[data-error-for]").forEach(function (node) {
      hide(node);
    });
    form.querySelectorAll("[aria-invalid]").forEach(function (node) {
      node.removeAttribute("aria-invalid");
    });
    if (nfrBox) nfrBox.classList.remove("is-invalid");
    Object.keys(errors).forEach(function (key) {
      var field = form.elements[key];
      if (field && field.setAttribute) field.setAttribute("aria-invalid", "true");
      var node = form.querySelector('[data-error-for="' + key + '"]');
      if (node) show(node, errors[key]);
    });
    if (errors.company && nfrBox) nfrBox.classList.add("is-invalid");
  }

  function clearError(form, name) {
    var field = form.elements[name];
    if (field) field.removeAttribute("aria-invalid");
    var node = form.querySelector('[data-error-for="' + name + '"]');
    if (node) hide(node);
  }

  function show(el, text) {
    if (!el) return;
    if (text) el.textContent = text;
    el.hidden = false;
  }

  function hide(el) {
    if (!el) return;
    el.hidden = true;
  }
})();